// extracted by mini-css-extract-plugin
export default {"header_logo":"ui_header_logo__i4Fo3","gr_1fr_auto":"ui_gr_1fr_auto__MB6LQ"};